import React from "react";
import {Alert as AntdAlert} from "antd";
import {WarningOutlined, ExclamationCircleOutlined} from "@ant-design/icons";

const Alert = props => {
    const {type, icon, className, ...other} = props;

    let colourClass = "";
    let extraOptions = {};
    if (type == "success") {
        colourClass = "ch-alert-success";
    } else if (type == "warning") {
        colourClass = "ch-alert-warning";
        extraOptions.icon = <WarningOutlined />;
    } else if (type == "error") {
        colourClass = "ch-alert-error";
        extraOptions.icon = <ExclamationCircleOutlined />;
    }

    return (
        <AntdAlert
            className={colourClass + (className ? " " + className : "")}
            type={type}
            {...extraOptions}
            {...other}
        />
    )
}

export default Alert;